import { render, staticRenderFns } from "./secondaryTableGroup.vue?vue&type=template&id=3154640e&scoped=true&"
import script from "./secondaryTableGroup.vue?vue&type=script&lang=js&"
export * from "./secondaryTableGroup.vue?vue&type=script&lang=js&"
import style0 from "./secondaryTableGroup.vue?vue&type=style&index=0&id=3154640e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154640e",
  null
  
)

export default component.exports